export const LECTURE_TICKETS_QUERY_PARAMS = {
  paymentType: 'paymentType',
  langType: 'langType',
  lessonCountPerMonth: 'lessonCountPerMonth',
  lessonTime: 'lessonTime',
  enable: 'enable',
  promotionType: 'promotionType',
} as const
